import { Phase } from "@1games-ru/region-shared/dist/enums/death/phase";
import { AnimatePresence } from "motion/react";
import useShowDeathScreen from "@/domains/deathScreen/hooks/useShowDeathScreen";
import DeathScreenActionsContainer from "@/domains/deathScreen/containers/DeathScreenActionsContainer";
import DeathScreenDescription from "@/domains/deathScreen/components/DeathScreenDescription";
import DeathScreenIcon from "@/domains/deathScreen/components/DeathScreenIcon";
import DeathScreenRedGradient from "@/domains/deathScreen/components/DeathScreenRedGradient";
import DeathScreenTimer from "@/domains/deathScreen/components/DeathScreenTimer";
import DeathScreenTitle from "@/domains/deathScreen/components/DeathScreenTitle";
import DeathScreenWrapper from "@/domains/deathScreen/components/DeathScreenWrapper";
import DeathScreenСardiogram from "@/domains/deathScreen/components/DeathScreenСardiogram";

export default function DeathScreenContainer() {
  const { isShow, deathState, seconds, minutes, isWaitingAmbulance, ambulanceIsComing, actions } =
    useShowDeathScreen();

  const show = isShow;

  return (
    <AnimatePresence>
      {show ? (
        <>
          <DeathScreenWrapper className="z-1">
            <div className="flex flex-col gap-1 items-center">
              <DeathScreenIcon />
              <DeathScreenTimer seconds={seconds} minutes={minutes} className="mt-5" />
              <DeathScreenTitle
                isWaitingAmbulance={isWaitingAmbulance}
                ambulanceIsComing={ambulanceIsComing}
                phase={deathState.phase}
              />
            </div>
            <DeathScreenСardiogram isPulse={deathState.phase === Phase.CriticalCondition} />
            <DeathScreenDescription {...deathState} />
          </DeathScreenWrapper>
          <DeathScreenRedGradient
            className="z-0"
            isPulse={deathState.phase === Phase.CriticalCondition}
          />
          <DeathScreenActionsContainer
            actions={actions}
            className="fixed bottom-[--boundary-offset-y] left-[50%] z-1"
          />
        </>
      ) : null}
    </AnimatePresence>
  );
}
